import { useMutation, useQuery } from "react-query";
import { normalFetch } from "../../fetch-api/get";
import { useQueryContext } from "../../../contexts/query";
import { postApi } from "../../fetch-api/post";
import { patchApi } from "../../fetch-api/patch";
import { deleteApi } from "../../fetch-api/delete";

export const suggestionKeys = {
    getSuggestions: 'getSuggestions',
    getSuggestionById: 'getSuggestionById',
    setSuggestion: 'setSuggestion',
    editSuggestion: 'editSuggestion',
    deleteSuggestion: 'deleteSuggestion',

}

export const useGetSuggestions = () => {
    return useQuery(
        suggestionKeys.getSuggestions,
        () => normalFetch('suggestion'),
        {
            select: res => res?.data?.data?.data
        }
    )
}
export const useGetSuggestionById = (id, options = {}) => {
    return useQuery(
        [suggestionKeys.getSuggestionById, id],
        () => normalFetch(`suggestion/${id}`),
        {
            enabled: options.enabled || false,
            select: res => res?.data?.data
        }
    )
}

export const useAddSuggestion = (onSuccess = () => { }) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        suggestionKeys.setSuggestion,
        (payload) => postApi(payload, 'suggestion'),
        {
            onSuccess: () => {
                setToast({ message: 'suggestion-added-success', show: true })
                queryClient.invalidateQueries([suggestionKeys.getSuggestions])
                onSuccess()
            }
        }
    )
}

export const useUpdateSuggestion = (onSuccess = () => { }) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        suggestionKeys.editSuggestion,
        (payload) => patchApi(payload.data, `suggestion/${payload.id}`),
        {
            onSuccess: () => {
                setToast({ message: 'suggestion-edit-success', show: true })
                queryClient.invalidateQueries([suggestionKeys.getSuggestions])
                onSuccess()
            }
        }
    )
}

export const useDeleteSuggestion = (onSuccess = () => { }) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        suggestionKeys.deleteSuggestion,
        (payload) => deleteApi(`suggestion/${payload.id}`),
        {
            onSuccess: () => {
                setToast({ message: 'suggestion-delete-success', show: true })
                queryClient.invalidateQueries([suggestionKeys.getSuggestions])
                onSuccess()
            }
        }
    )
}